/**
 * TanStack Query hooks for `real-time-conversion-fraud-detection`.
 *
 * Live pulse: refetchInterval 5s so the operator sees a continuously
 * updating feed of fraud verdicts without manual refresh. The page
 * shows a live green dot while fetching and keeps previous data on
 * refetch so the rows don't flicker.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	list,
	realTimeConversionFraudDetectionQueryKeys,
	type ListRealTimeConversionFraudDetectionResponse,
} from "./api";

export const REFETCH_INTERVAL_MS = 5_000;

export function useRealTimeConversionFraudDetectionQuery(): UseQueryResult<
	ListRealTimeConversionFraudDetectionResponse,
	Error
> {
	return useQuery({
		queryKey: realTimeConversionFraudDetectionQueryKeys.list(),
		queryFn: list,
		refetchInterval: REFETCH_INTERVAL_MS,
		refetchIntervalInBackground: false,
		staleTime: 0,
	});
}

// Back-compat alias matching the scaffold-generated name so the shared
// owned-files contract doesn't blink. The page uses the explicit name.
export const useRealTimeConversionFraudDetectionList =
	useRealTimeConversionFraudDetectionQuery;
